import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';

export const SystemBinStatus = {
  id: '00000000-0000-0000-0000-000000000001',
  status: 'SYSTEM',
};

export class BinStatus extends CompanyEntity {
  status!: string;
  color: string = '#A3A3A3';
  inboundAllowed?: boolean = false;
  outboundAllowed?: boolean = false;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}
